import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import { requestOtp } from '../../api/apiOtp';

/**
 * Hook for requesting OTP codes
 * @returns {Object} Mutation object with cooldown state
 */
export const useOtpRequest = () => {
    const [cooldownSeconds, setCooldownSeconds] = useState(0);
    const [expiresAt, setExpiresAt] = useState(null);

    const mutation = useMutation({
        mutationFn: ({ channel, identifier, purpose }) => {
            return requestOtp(channel, identifier, purpose);
        },
        onSuccess: (data) => {
            // Store cooldown and expiry information
            if (data?.data?.cooldown_seconds) {
                setCooldownSeconds(data.data.cooldown_seconds);
            }
            if (data?.data?.expires_at) {
                setExpiresAt(data.data.expires_at);
            }
        },
        onError: (error) => {
            // Handle cooldown from error response (429)
            if (error?.response?.status === 429) {
                const retryAfter = error.response.data?.meta?.retry_after ||
                    error.response.data?.meta?.remaining_seconds;
                if (retryAfter) {
                    setCooldownSeconds(retryAfter);
                }
            }
        }
    });

    return {
        ...mutation,
        cooldownSeconds,
        expiresAt,
        setCooldownSeconds // Allow manual countdown updates
    };
};
